import { TopBox } from './fixed';
import { Link } from 'react-router-dom';
import { PhunChara } from './phunChara';

import { dictContext } from '../App';
import { useContext } from 'react';

export const TopPage = () => {
    const dict = useContext(dictContext)

    return (
        <div className='topWrapper'>
            <TopBox/>
            <p>
                人工言語「
                <a href="https://kaeru2193.net/phunlang" target="_blank">雰語</a>
                」で用いられる表語文字体系「雰字」のオンライン字典です。現在<b>{dict.length}</b>文字が収録されています。
            </p>
            <h2>雰字一覧</h2>

            <div className='charaList'>
                {dict.map(v =>
                    <CharaLink id={v.id} chara={v.chara} desc={v.chara} key={v.id}/>
                )}
            </div>
        </div>
    )
}

export const CharaLink = (props: {id: string, chara: string, desc: string}) => <Link to={`/chara/${props.id}`}>
    <div className='charaLink'>
        <span className='chara'>
            <PhunChara>{props.chara}</PhunChara>
        </span>
        <span className='charaPron serif'>{props.desc}</span>
    </div>
</Link>